export const LEAT_SOURCE_FIELDS = [
  { source: "first_name", label: "First name" },
  { source: "last_name", label: "Last name" },
  { source: "phone_number", label: "Phone number" },
  { source: "dob", label: "Date of birth" },
  { source: "gender", label: "Gender" },
  { source: "age", label: "Age" },
];

export const DEFAULT_LEAT_FIELD_MAPPINGS = {
  first_name: "firstname",
  last_name: "lastname",
  phone_number: "phonenumber",
  dob: "birthdate",
  gender: "gender",
  age: "age_group",
};

export const READ_ONLY_LEAT_ATTRIBUTES = new Set([
  "age",
  "created_at",
  "credit_balance",
  "uuid",
  "email",
]);

export const NONE_LEAT_ATTRIBUTE = "__none__";

export function normalizeLeatFieldMappings(value) {
  const incoming = value && typeof value === "object" ? value : {};
  const normalized = {};
  LEAT_SOURCE_FIELDS.forEach(({ source }) => {
    if (Object.prototype.hasOwnProperty.call(incoming, source)) {
      normalized[source] = String(incoming[source] || "").trim();
    } else {
      normalized[source] = DEFAULT_LEAT_FIELD_MAPPINGS[source];
    }
  });
  return normalized;
}

export function toSelectValue(leatAttribute) {
  return leatAttribute ? leatAttribute : NONE_LEAT_ATTRIBUTE;
}

export function fromSelectValue(value) {
  return value === NONE_LEAT_ATTRIBUTE ? "" : value;
}

export function buildLeatAttributeOptions(attributes, fieldMappings) {
  const options = [];
  const seen = new Set();

  const addOption = (name, label) => {
    if (!name || seen.has(name) || READ_ONLY_LEAT_ATTRIBUTES.has(name)) return;
    seen.add(name);
    options.push({ name, label: label || name });
  };

  (Array.isArray(attributes) ? attributes : []).forEach((attr) => {
    addOption(attr?.name, attr?.label);
  });

  Object.values(DEFAULT_LEAT_FIELD_MAPPINGS).forEach((name) => addOption(name, name));
  Object.values(fieldMappings || {}).forEach((name) => addOption(name, name));

  return options;
}
